const accessTokenCookieName = process.env.NEXT_PUBLIC_COOKIES_TOKEN_NAME || 'token';
export default accessTokenCookieName;
